// extracted by mini-css-extract-plugin
module.exports = {"btn":"styled-button_btn__D1VoI","btn_dis_wrapper":"styled-button_btn_dis_wrapper__OdtO_","btn_title":"styled-button_btn_title__6iBB4","loader":"styled-button_loader__MKqiY"};